import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ThemeService } from '../services/theme.service';
import { ITheme } from '../models/ITheme';
import { ThemeFormComponent } from './theme-form/theme-form.component';

@Component({
  selector: 'app-themes',
  templateUrl: './themes.component.html',
  styleUrls: ['./themes.component.scss']
})
export class ThemesComponent implements OnInit {
  @ViewChild(ThemeFormComponent) child: ThemeFormComponent;
  themes: ITheme[];
  filteredThemes: ITheme[];
  subscription: Subscription;

  constructor(private themeService: ThemeService) { }

  ngOnInit(): void {
    this.subscription = this.themeService.getAll().subscribe(res => {
      this.themes = res;
      this.filteredThemes = this.themes;
    });
  }

  delete(id: string) {
    const result = confirm('You really want to delete this theme?').valueOf();
    if (result) { return this.themeService.delete(id); }
  }

  edit(theme: ITheme) {
    this.child.buildForm(theme);
  }

  filter(field: string, value: string) {
    this.filteredThemes = this.themes.filter(i => i[field].toLowerCase().includes(value.toLowerCase()));
  }


}
